import React from "react";
import gtmParts from "react-google-tag-manager";

let GTMDataLayerName = "";

export interface IGoogleTagManagerProps {
  gtmId: string;
  dataLayerName: string;
  scriptId: string;
  additionalEvents: object;
  previewVariables: string;
  scheme: string;
}

export class GoogleTagManager extends React.Component<IGoogleTagManagerProps> {
  public static defaultProps = {
    additionalEvents: {},
    previewVariables: "",
    scheme: "https:",
  };

  public componentDidMount() {
    const scriptId = this.props.scriptId;
    GTMDataLayerName = this.props.dataLayerName;

    if (!window[GTMDataLayerName]) {
      const gtmScriptNode = document.getElementById(scriptId);

      if (gtmScriptNode) {
        try {
          global.eval(gtmScriptNode.textContent as string);
        } catch (e) {
          console.warn("GTM: Failed to initialize", e);
        }
      }
    }
  }

  public render() {
    try {
      const {
        gtmId,
        dataLayerName,
        scriptId,
        additionalEvents,
        previewVariables,
        scheme,
      } = this.props;
      const gtm = gtmParts({
        id: gtmId.trim(),
        previewVariables,
        dataLayerName,
        additionalEvents,
        scheme,
      });

      return (
        <React.Fragment>
          {gtm.noScriptAsReact()}
          <div id={scriptId}>{gtm.scriptAsReact()}</div>
        </React.Fragment>
      );
    } catch (e) {
      console.warn("GTM: Failed to initialize", e);

      return null;
    }
  }
}

export function pushToDataLayer(object: object) {
  if (window[GTMDataLayerName]) {
    window[GTMDataLayerName].push(object);
  }
}
